import { makeStyles, Typography } from "@material-ui/core"
import Button from "@material-ui/core/Button"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogTitle from "@material-ui/core/DialogTitle"
import React, { useState } from "react"
import { useDispatch } from "react-redux"
import { acknowledgeAllUserAlerts, fetchUserAlerts } from "../../actions/alertActions"

const useStyles = makeStyles({
  checkboxContainer: {
    display: "flex",
    alignItems: "center",
  },
  checkbox: {
    paddingLeft: 0,
  },
  button: {
    marginRight: 15,
  },
})

export default function AckAllAlertsModal() {
  const [open, setOpen] = useState(false)
  const classes = useStyles()
  const dispatch = useDispatch()

  const handleConfirm = async () => {
    await acknowledgeAllUserAlerts()
    dispatch(fetchUserAlerts())
    setOpen(false)
  }

  return (
    <>
      <Button
        className={classes.button}
        variant="outlined"
        color="primary"
        onClick={() => {
          setOpen(true)
        }}
      >
        Acknowledge All
      </Button>
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>Acknowledge All New Alerts?</DialogTitle>
        <DialogContent>
          <Typography>All new alerts will be set to acknowledged.</Typography>
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={() => setOpen(false)}>
            Cancel
          </Button>
          <Button color="primary" onClick={handleConfirm} variant="contained">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
